import { MessageService } from 'primeng/api';
import { Severity, MessageSummary } from '../enums/message.enum';

export class ToastUtil {
    static showSuccess(messageService: MessageService, detail: string, summary: string = MessageSummary.SUCCESS) {
        messageService.add({ severity: Severity.SUCCESS, summary, detail });
    }

    static showInfo(messageService: MessageService, detail: string, summary: string = MessageSummary.INFO) {
        messageService.add({ severity: Severity.INFO, summary, detail });
    }

    static showWarn(messageService: MessageService, detail: string, summary: string = MessageSummary.WARN) {
        messageService.add({ severity: Severity.WARN, summary, detail });
    }

    static showError(messageService: MessageService, detail: string, summary: string = MessageSummary.ERROR) {
        messageService.add({ severity: Severity.ERROR, summary, detail });
    }
}
